import React, { Component } from 'react';
import HighChart from '../payg/commonModules/interface/HighChart';
import HighChartPie from '../payg/commonModules/interface/HighChartPie';
import Select from 'react-select'
import { Card, FormControl, InputLabel, OutlinedInput,NativeSelect } from '@material-ui/core';
import { InputSelect } from '../payg/commonModules/interface/form-input-inline';

const Months = [
    'Janvier',
    'Fevrier',
    'Mars',
    'Avril',
    'Mai',
    'Juin',
    'Juillet',
    'Aout',
    'Septembre',
    'Octobre',
    'Novembre',
    'Décembre'
]
const oneYear = 365 * 24 * 60 * 60 * 1000

const sortByDate = (list, field = "date") => {
    list.sort((a, b) => {
        a = new Date(a[field]);
        b = new Date(b[field]);
        if (a > b){
            return 1;
        }
        if (a < b){
            return -1;
        }
        return 0;
    });
    return list
} 
const groupByDate = (list, field) => {
    let groupList = {}
    list = sortByDate(list)
    list.forEach( item => {
        let key = Months[new Date(item[field]).getMonth()] +" "+ new Date(item[field]).getFullYear()
        if( !groupList[key] ) {
            groupList[key] = []
        }  
        groupList[key].push(item)
    })
    return groupList
}
const groupBy = (list, field) => {
    let groupList = {}
    list.forEach( item => {
        if( !groupList[item[field]] ) {
            groupList[item[field]] = []
        }  

        groupList[item[field]].push(item)
    })
    return groupList
}

const countList = (list, field) => {
    return list.reduce( (acc, obj) => {
        var key = obj[field]            
        
        if(!acc[key]){
            acc[key] = 0;
        }
        acc[key] ++;
        return acc;
    }, {});
}
const count = (list) => {
    return list.reduce( (acc, obj) => {
        
        if(!acc[obj]){
            acc[obj] = 0;
        }
        acc[obj] ++;
        return acc;
    }, {});
}

export class SalesStackBar extends Component {
    state = { 
        // selectGraphDisplay: {value: "subscriptionName", label: "Type Abonnement"},
        selectGraph: "subscriptionName",
    }
 
    filterList = (list = this.props.agentsList) => {

        let dateLimit = this.state.dateLimit || (Date.now() - oneYear)
        list = list.filter( item => new Date(item.date) > dateLimit)
        let nbPerAgentlist = countList(list, this.state.selectGraph)
        let topAgents = Object.keys(nbPerAgentlist).sort( (a, b) => nbPerAgentlist[b] - nbPerAgentlist[a])

        console.log('====================================');
        console.log({list, topAgents, nbPerAgentlist});
        console.log('====================================');

        return {list, topAgents: topAgents, nbPerAgentlist}
        // return {list, topAgents: topAgents.slice(0, 6), nbPerAgentlist}
    }
    calcDataStack = () => {
        let all = []
        let series = []
        let formatted = {}
        let info = this.filterList()
        
        let list = info.list
        let typeList = info.topAgents

        let categories = groupByDate(list, "date")

        Object.keys(categories).forEach( date => {
            all[date] = countList(categories[date], this.state.selectGraph)
        })

        typeList.forEach(type => {
            Object.values(all).forEach( data => {
                if(!formatted[type]){
                    formatted[type] = []
                }
                formatted[type].push(data[type] || 0)
            })
        })
        Object.keys(formatted).forEach( type => {
            series.push({
                name:type,
                data: formatted[type],
            })
        })
        console.log('====================================');
        console.log({categories, formatted, all, series});
        console.log('====================================');
        return {categories : Object.keys(categories), series}
    }
    handleChange = (option) => {
        console.log('====================================');
        console.log({option});
        console.log('====================================');
        this.setState({ 
            selectGraph: option.value
        }) 
    
    }
    render() {
        let info_stack = this.calcDataStack()
        
        return (
            <div>
                {/* <Select
                    options={[
                       { value:"subscriptionName", label:"Type Abonnement" },
                       { value:"commercialName", label:"Commercial" },
                       { value:"commercialZone", label:"Zone" },
                    ]}
                    value={this.state.selectGraphDisplay }
                    onChange={ option =>
                        this.setState({ 
                            selectGraphDisplay: option, 
                            selectGraph:option.value
                        }) 
                    }
                />  */}
                <InputSelect 
                    label="Trier Par"
                    value={this.state.selectGraph }
                    onChange={this.handleChange}
                    options={[
                        { value: "subscriptionName", label:"Type d'Abonnement" },
                        { value: "commercialZone", label:"Zone" },
                        { value: "commercialName", label:"Commercial" },
                    ]}
                />
                
                <HighChart 
                    title="Analyse Ventes (12 derniers mois)"
                    titleY="Nombre de ventes"
                    type="column"
                    categories={info_stack.categories}
                    series={info_stack.series}

                />
            </div>
        );
    }
}

export class SalesPie extends Component {
    state = { 

    }

    calcDataPie = () => {
        let series = []
        let list = this.props.agentsList
        
        list = list.map( sale =>  sale.subscriptionName)

        let nbPerAbolist = count(list)
        Object.keys(nbPerAbolist).sort( (a, b) => nbPerAbolist[b] - nbPerAbolist[a]).map( abo => {
            series.push(
                {name:abo, y: nbPerAbolist[abo]}
            )
        })
        
        console.log('====================================');
        console.log({list, nbPerAbolist, series});
        console.log('====================================');
        return {series}
    }
    render() {
        let info_pie = this.calcDataPie()
       
        return (
            <div className="card">
                <HighChartPie title="Répartition des ventes par abonnement" nameData="Nombre de ventes" series={info_pie.series}/>
            </div>
        );
    }
}

export class AgentsStackBar extends Component {
    state = { 
        selectGraphDisplay: {value: "commercialName", label: "Commercial"},
        selectGraph: "commercialName",
    }
 
    filterList = (list = this.props.agentsList) => {

        let dateLimit = this.state.dateLimit || (Date.now() - oneYear)
        list = list.filter( item => new Date(item.date) > dateLimit)
        let nbPerAgentlist = countList(list, this.state.selectGraph)
        let topAgents = Object.keys(nbPerAgentlist).sort( (a, b) => nbPerAgentlist[b] - nbPerAgentlist[a])

        console.log('====================================');
        console.log({list, topAgents, nbPerAgentlist});
        console.log('====================================');

        return {list, topAgents: topAgents.slice(0, 6), nbPerAgentlist}
    }
    calcDataStack = () => {
        let all = []
        let series = []
        let formatted = {}
        let info = this.filterList()
        
        let list = info.list
        let typeList = info.topAgents

        let categories = groupByDate(list, "date")

        Object.keys(categories).forEach( date => {
            all[date] = countList(categories[date], this.state.selectGraph)
        })

        typeList.forEach(type => {
            Object.values(all).forEach( data => {
                if(!formatted[type]){
                    formatted[type] = []
                }
                formatted[type].push(data[type] || 0)
            })
        })
        Object.keys(formatted).forEach( type => {
            series.push({
                name:type,
                data: formatted[type],
            })
        })
        console.log('====================================');
        console.log({categories, formatted, all, series});
        console.log('====================================');
        return {categories : Object.keys(categories), series}
    }
    
    render() {
        let info_stack = this.calcDataStack()
        
        return (
            <Card>
                <InputSelect
                    options={[
                       { value:"commercialZone", label:"Zone" },
                       { value:"commercialName", label:"Commercial" },
                    ]}
                    value={this.state.selectGraph }
                    onChange={ option =>
                        this.setState({ 
                            selectGraphDisplay: option, 
                            selectGraph:option.value
                        }) 
                    }
                /> 
                {/* <FormControl variant="outlined" style={{width: "100%"}}>
                    <InputLabel htmlFor="selectGraph">Trier par</InputLabel>
                    <NativeSelect
                        native
                        onChange={ e =>
                            this.setState({ 
                                selectGraph: e.target.value
                            }) 
                        }
                        value={this.state.selectGraph}
                        input={<OutlinedInput labelWidth={200} name="selectGraph" id="selectGraph" />}
                    >
                        <option value="commercialZone">Zone</option>
                        <option value="commercialName">Commercial</option>
                    </NativeSelect>
                </FormControl> */}
                <HighChart 
                    title="Performance Commerciaux (12 derniers mois)"
                    titleY="Nombre de ventes"
                    type="column"
                    categories={info_stack.categories}
                    series={info_stack.series}

                />
            </Card>
        );
    }
}